import create from './create';
import TYPES from './action/ACTION_TYPE';

export const Types = TYPES;

export default{
  create,
};
